export default "__VITE_ASSET__ymdDXGJ1__"